<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg
      v-if="exceptionMsg"
      :msg="exceptionMsg"
      :image="exceptionImg"
    />

    <GovernateForm
      v-if="!isLoading"
      :governateData="governorateData"
      :submitName="$t('add')"
      v-on:addOrUpdateGovernate="addOrUpdateGovernate"
    />
  </div>
</template>

<script>
import createToastMixin from "@/utils/create-toast-mixin";
import { STATUS } from "@/utils/constants";
import GovernateForm from "@/components/settings/settingsOther/governates/GovernateForm.vue";
import Governate from "@/models/settings/settingsOther/governates/Governate";

export default {
  name: "GovernateAdd",
  mixins: [createToastMixin],
  components: {
    GovernateForm,
  },
  data() {
    return {
      isLoading: false,

      governorateData: new Governate(),
    };
  },
  methods: {
    async addOrUpdateGovernate() {
      this.isLoading = true;
      try {
        let response = await this.governorateData.addOrUpdateGovernate(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.governorateData.setInitialValue();
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        this.errorCatch();
      }
      this.isLoading = false;
    },
  },
  async created() {},
};
</script>

<style scoped lang="scss"></style>
